var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-container" }, [
          _c("div", { staticClass: "modal-close" }, [
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _vm._t("modal-close", function () {
                  return [_vm._v("x")]
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-header" },
            [
              _vm._t("header", function () {
                return [_vm._v("\n            default header\n          ")]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm._t("body", function () {
                return [_vm._v("\n            default body\n          ")]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "div",
              {
                staticClass: "modal-default-button",
                on: {
                  click: function ($event) {
                    return _vm.donate()
                  },
                },
              },
              [
                _vm._t("bottm-button", function () {
                  return [_vm._v("\n              Button\n            ")]
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }